import QuestionsData from "../data";
export const mapQuestionList = () => {
  const questionsList: {
    question: string;
    url: string;
  }[] = [];

  QuestionsData.conditions[0].sections.forEach(({ questions, title, url }) => {
    questionsList.push({
      question: title,
      url,
    });
    questions.forEach(({ question }) => {
      questionsList.push({ question, url });
    });
  });

  return questionsList;
};
